if (!customElements.get('hy-qty')) {
  customElements.define('hy-qty', class extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('input');
      this.querySelectorAll('[data-step]').forEach((btn) => btn.addEventListener('click', () => {
        const next = (parseInt(input.value, 10) || 1) + Number(btn.dataset.step);
        input.value = Math.max(1, next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }));
    }
  });
}

// Variant dropdown (multi-variant products): keep price, compare price, button state and image in sync.
document.querySelectorAll('.hy-sp__variant').forEach((select) => {
  select.addEventListener('change', () => {
    const opt = select.selectedOptions[0];
    const root = select.closest('.hy-sp');
    if (!opt || !root) return;
    root.querySelector('.hy-sp__now').innerHTML = opt.dataset.price;
    const was = root.querySelector('.hy-sp__was');
    was.innerHTML = opt.dataset.compare || '';
    was.hidden = !opt.dataset.compare;
    const btn = root.querySelector('.hy-sp__atc');
    const available = opt.dataset.available === 'true';
    btn.disabled = !available;
    btn.querySelector('span').textContent = available ? btn.dataset.label : btn.dataset.soldOut;
    const img = root.querySelector('.hy-sp__media img');
    if (img && opt.dataset.image) { img.removeAttribute('srcset'); img.src = opt.dataset.image; }
  });
});
